var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(!_vm.dashboard)?_c('Navigation'):_vm._e(),_c('router-view',{staticClass:"content",class:{dashboard: _vm.dashboard}}),(!_vm.dashboard)?_c('Press'):_vm._e(),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }